
<div
    class="Section HeroSection"
    :class="[variant, { 'has-overlay': overlay, 'has-background-image': backgroundImage }]"
    :style="backgroundImageStyle"
>
    <div
        v-if="backgroundImage && typeof backgroundImage === 'object'"
        class="HeroBackgroundImage"
    >
        <picture>
            <source
                v-if="backgroundImage.webp"
                :srcset="backgroundImage.webp"
                type="image/webp"
            />
            <source
                v-if="backgroundImage.jpg"
                :srcset="backgroundImage.jpg"
                type="image/jpeg"
            />
            <img
                :src="backgroundImage.src"
                :alt="backgroundImage.alt || ''"
                class="BackgroundImage"
                :loading="backgroundImage.loading || 'eager'"
                :decoding="backgroundImage.decoding || 'async'"
            />
        </picture>
    </div>
    <div v-if="overlay" class="HeroOverlay" :style="overlayStyle"></div>
    <div class="Content" :class="{ 'has-image': image }">
        <div class="HeroContent">
            <div class="TextContent">
                <div v-if="badge" class="HeroBadge">
                    <slot name="badge">
                        <i v-if="badgeIcon" :class="badgeIcon"></i>
                        <span>{{ badge }}</span>
                    </slot>
                </div>

                <h1 class="HeroTitle" :lang="lang">
                    <slot name="title">
                        <span v-if="titleHighlight" class="TitleHighlight">{{
                            titleHighlight
                        }}</span>
                        <span v-html="title"></span>
                    </slot>
                </h1>

                <p v-if="subtitle" class="HeroSubtitle" :lang="lang">
                    <slot name="subtitle">{{ subtitle }}</slot>
                </p>

                <div v-if="hasActions" class="HeroActions">
                    <slot name="actions">
                        <router-link
                            v-if="primaryAction"
                            :to="primaryAction.to"
                            class="PrimaryAction"
                            @click.native="handlePrimaryClick"
                        >
                            <SiteButton>
                                <span class="ButtonText">{{ primaryAction.text }}</span>
                                <i
                                    v-if="primaryAction.icon"
                                    :class="primaryAction.icon + ' ButtonIcon'"
                                ></i>
                            </SiteButton>
                        </router-link>
                        <a
                            v-if="secondaryAction"
                            :href="secondaryAction.href"
                            class="SecondaryAction"
                            @click="handleSecondaryClick"
                        >
                            <span>{{ secondaryAction.text }}</span>
                            <i v-if="secondaryAction.icon" :class="secondaryAction.icon"></i>
                        </a>
                    </slot>
                </div>

                <slot name="additional"></slot>
            </div>

            <div v-if="image" class="HeroVisual">
                <div class="HeroImageContainer">
                    <picture class="HeroImage">
                        <source v-if="image.webp" :srcset="image.webp" type="image/webp" />
                        <source v-if="image.jpg" :srcset="image.jpg" type="image/jpeg" />
                        <img
                            :src="image.src"
                            :alt="image.alt || 'Hero Image'"
                            class="HeroImage"
                            :width="image.width"
                            :height="image.height"
                            :loading="image.loading || 'eager'"
                            :decoding="image.decoding || 'async'"
                        />
                    </picture>
                </div>
            </div>
        </div>
    </div>
</div>
